var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M5.38 12.911c-.528.29-1.143-.178-1.043-.79l.5-3.048-2.12-2.158c-.426-.434-.19-1.19.399-1.28l2.93-.444 1.31-2.773a.705.705 0 0 1 1.288 0l1.31 2.773 2.93.444c.59.09.825.846.398 1.28l-2.12 2.158.5 3.048c.101.612-.514 1.08-1.041.79L8 11.472l-2.62 1.44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2a771a3721828a9540955fb4c6af0a4b.svg";
export { ForwardRef as ReactComponent };